module.exports = new __parcel__URL__("train_20_active.e472455c.png").toString();